import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import { Home, Plus, Map, TrendingUp, User, FileText, MessageSquare, Info } from 'lucide-react';

const BottomNavigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const { themeClasses } = useTheme();

  const isActive = (path: string) => location.pathname === path;

  if (!user) return null;

  const founderTabs = [
    { path: '/pitch', icon: Plus, label: 'Pitch' },
    { path: '/roadmap', icon: Map, label: 'Roadmap' },
    { path: '/', icon: Home, label: 'Home' },
    { path: '/funded', icon: TrendingUp, label: 'Funded' },
    { path: '/profile', icon: User, label: 'Profile' },
  ];

  const groupATabs = [
    { path: '/funded', icon: TrendingUp, label: 'Funded' },
    { path: '/', icon: Home, label: 'Home' },
    { path: '/profile', icon: User, label: 'Profile' },
  ];

  const ownerTabs = [
    { path: '/', icon: Home, label: 'Home' },
    { path: '/admin/users', icon: User, label: 'Users' },
    { path: '/admin/funding', icon: TrendingUp, label: 'Funding' },
    { path: '/terms', icon: FileText, label: 'Terms & Privacy' },
    { path: '/admin/faq', icon: MessageSquare, label: 'FAQ' },
    { path: '/admin/about', icon: Info, label: 'About' },
  ];

  let tabs;
  if (user.accountType === 'founder') {
    tabs = founderTabs;
  } else if (user.accountType === 'group_a') {
    tabs = groupATabs;
  } else if (user.accountType === 'owner') {
    tabs = ownerTabs;
  } else {
    tabs = groupATabs; // fallback
  }

  return (
    <div className={`fixed bottom-0 left-0 right-0 ${themeClasses.navigation} z-50`}>
      <div className="flex justify-around items-center h-16 px-4">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.path}
              onClick={() => navigate(tab.path)}
              className={`flex flex-col items-center justify-center flex-1 h-full transition-all duration-300 ${
                isActive(tab.path)
                  ? 'text-cyan-600 scale-110'
                  : `${themeClasses.textSecondary} hover:${themeClasses.text} hover:scale-105`
              }`}
            >
              <Icon className="w-6 h-6 mb-1" />
              <span className="text-xs font-medium">{tab.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BottomNavigation; 